(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["veroshape-kaching-bonus-visual"] && !Shopify.designMode) return;
  try {
    (() => {
    const imageUrls = {
      6: 'https://cdn.shopify.com/s/files/1/0685/2968/4568/files/Kaching-Bundles-Discount_and_gifts_from_VEROSHAPE_BULK_SALE_1.webp?v=1784222190',
      8: 'https://cdn.shopify.com/s/files/1/0685/2968/4568/files/Kaching-Bundles-Discount_and_gifts_from_VEROSHAPE_BULK_SALE_2.webp?v=1784222211',
    };

    const altTexts = {
      6: 'VEROSHAPE 6-Pack bonuses: guide, free shipping, and 60-day guarantee',
      8: 'VEROSHAPE 8-Pack advantages: guide, free shipping, and lowest price per tank',
    };

    const panel = document.getElementById('vs-kaching-bonus-visual');
    const image = document.getElementById('vs-kaching-bonus-image');
    let updateFrame;

    if (!panel || !image) return;

    Object.values(imageUrls).forEach((url) => {
      const preload = new Image();
      preload.src = url;
    });

    function renderQuantity(quantity) {
      const url = imageUrls[quantity];

      if (!url) {
        panel.hidden = true;
        image.removeAttribute('src');
        image.alt = '';
        return;
      }

      image.src = url;
      image.alt = altTexts[quantity];
      panel.hidden = false;
    }

    function quantityFromWidget(widget) {
      const root = widget.shadowRoot || widget;
      const selectedElements = root.querySelectorAll(
        'input[type="radio"]:checked, [aria-checked="true"], [data-selected="true"]'
      );

      for (const selectedElement of selectedElements) {
        let element = selectedElement;

        for (let depth = 0; element && depth < 8; depth += 1) {
          const text = (element.textContent || '').replace(/\s+/g, ' ').toUpperCase();

          if (text.includes('8-PACK')) return 8;
          if (text.includes('6-PACK')) return 6;
          if (text.includes('4-PACK')) return 4;
          if (text.includes('2-PACK')) return 2;

          element = element.parentElement;
        }
      }

      return null;
    }

    function scheduleDomUpdate(widget) {
      window.cancelAnimationFrame(updateFrame);
      updateFrame = window.requestAnimationFrame(() => {
        const quantity = quantityFromWidget(widget);
        if (quantity) renderQuantity(quantity);
      });
    }

    function connectWidget(widget) {
      if (widget.dataset.vsBonusVisualConnected === 'true') return;

      widget.dataset.vsBonusVisualConnected = 'true';
      widget.insertAdjacentElement('afterend', panel);

      widget.addEventListener('variants-changed', (event) => {
        const variantQuantities = event.detail && event.detail.variantIdQuantities;

        if (Array.isArray(variantQuantities)) {
          const quantity = variantQuantities.reduce(
            (total, variant) => total + Number(variant.quantity || 0),
            0
          );
          renderQuantity(quantity);
          return;
        }

        scheduleDomUpdate(widget);
      });

      widget.addEventListener('deal-bar-selected', () => {
        window.setTimeout(() => scheduleDomUpdate(widget), 80);
      });

      widget.addEventListener('click', () => {
        window.setTimeout(() => scheduleDomUpdate(widget), 120);
      });

      const widgetRoot = widget.shadowRoot || widget;
      const observer = new MutationObserver(() => scheduleDomUpdate(widget));
      observer.observe(widgetRoot, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      window.setTimeout(() => {
        const initialQuantity = quantityFromWidget(widget);
        renderQuantity(initialQuantity || 6);
      }, 250);
    }

    function findAndConnectWidget() {
      const widget = document.querySelector('kaching-bundles-block');
      if (!widget) return false;

      connectWidget(widget);
      return true;
    }

    if (!findAndConnectWidget()) {
      const pageObserver = new MutationObserver(() => {
        if (findAndConnectWidget()) pageObserver.disconnect();
      });

      pageObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
